<template>
  <v-navigation-drawer width="400px" v-model="drawer" stateless overlay-opacity="0.2" fixed temporary clipped app>
    <template v-slot:prepend>

      <v-toolbar flat>
        <span class="text--primary subtitle-1 font-weight-bold">Filtro Contas a Receber</span>
        <v-spacer></v-spacer>
          <v-btn text icon @click="fechar">
            <v-icon>mdi-close-thick</v-icon>
          </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
    </template>

    <v-card flat>
      <v-card-text>
        <!-- <h1 class="text--primary subtitle-1 font-weight-bold">Filtro Contas a Receber</h1> -->

        <v-row dense no-gutters>
          <v-col cols="12">
            <v-autocomplete 
              v-model="filtro.empresa" 
              label="Empresa" 
              ref="responsavel" 
              return-object
              filled 
              placeholder=" " 
              clearable
              item-value="id"
              item-text="descricao"
              :items="listaEmpresas" 
            ></v-autocomplete>
          </v-col>

          <!-- <v-col cols="12">
            <v-autocomplete v-model="filtro.empresa" filled ref="responsavel" placeholder=" " label="Cliente Responsável" :items="listaEmpresas" clearable></v-autocomplete>
          </v-col> -->

          <v-col cols="12">
            <z-date-range-picker v-model="filtro.data_vencimento" filled ref="data_vencimento" placeholder=" " label="Intervalo Vencimento" clearable></z-date-range-picker>
          </v-col>

          <v-col cols="12">
            <z-date-range-picker v-model="filtro.data_recebimento" filled ref="data_recebimento" placeholder=" " label="Intervalo Recebimento" clearable></z-date-range-picker>
          </v-col>

          <v-col cols="12">
            <v-select 
              v-model="filtro.status" 
              label="Status" 
              ref="status" 
              return-object
              filled 
              placeholder=" " 
              clearable
              :items="[
                {text: 'Recebido', value: 'recebido'},
                {text: 'Em aberto', value: 'emaberto'},
              ]" 
            ></v-select>
          </v-col>

          <v-col cols="12" align="end">
            <v-btn depressed @click="redefinir" class="text-capitalize">
              <v-icon left>mdi-close</v-icon>Limpar
            </v-btn>
          </v-col>
        </v-row>
        
      </v-card-text>
    </v-card>

    <template v-slot:append>
      <v-divider></v-divider>
      <v-card flat>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="fechar" class="text-capitalize">Cancelar</v-btn>
          <v-btn depressed color="primary" @click="aplicar" class="text-capitalize" :loading="aplicando">Filtrar</v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-navigation-drawer>
</template>

<script>

  import { mapStores, mapState, mapActions } from "pinia";
  import { useListasStore } from "@/app/store/stores/listas";
  import { datasParaIntervaloBR } from "@/app/helpers/formatacoes";

  export default {
    data() {
      return {
        drawer: false,
        filtro: {
          empresa: null,
          data_vencimento: [],
          data_recebimento: [],
          status: ''
        },
        aplicando: false,
        filtroChips: []
      }
    },

    computed: {
      ...mapState(useListasStore, ['listaEmpresas', 'listaParceiros'])
    },

    methods: {
      ...mapActions(useListasStore, ['getEmpresas', 'getParceiros']),

      abrir() {
        // this.filtro = this.clone(this.$store.this.cheques.filtro);
        this.drawer = true;
        this.getEmpresas();
        this.getParceiros();
      },

      fechar() {
        this.drawer = false;
      },

      async aplicar() {
        try {
          this.aplicando = true;
          // await this.$store.dispatch('cheques/filtrarCheques', this.filtro);
          this.processarFiltro();
          this.fechar();
        } catch (error) {
          this.$eventbus.notificarErro(error);
          throw error;
        } finally {
          this.aplicando = false;
        }
      },

      redefinir() {
        this.filtro = {
          empresa: null,
          data_vencimento: [],
          data_recebimento: [],
          status: ''
        }

        this.aplicar(true);
      },

      validar() {
        if ( this.filtro.empresa == null && this.filtro.status == null && this.filtro.banco == null && this.filtro.data_vencimento.length == 0 && this.filtro.data_recebimento.length == 0)
            return false;

          return true;
      },

      processarFiltro() {
        let items = [];
        
        if (this.filtro.empresa) {
          items.push({descricao: 'Empresa: ' + this.filtro.empresa.descricao, chave: 'empresa', valor: this.filtro.empresa.id});
        }

        if (this.filtro.data_vencimento.length > 0) {
          let intervalo = datasParaIntervaloBR(this.filtro.data_vencimento);
          items.push({descricao: 'Vencimento: de ' + intervalo, chave: 'data_vencimento', valor: this.filtro.data_vencimento});
        }

        if (this.filtro.data_recebimento.length > 0) {
          let intervalo = datasParaIntervaloBR(this.filtro.data_recebimento);
          items.push({descricao: 'Recebimento: de ' + intervalo, chave: 'data_recebimento', valor: this.filtro.data_recebimento});
        }

        if (this.filtro.status) {
          items.push({descricao: 'Status: ' + this.filtro.status.text, chave: 'status', valor: this.filtro.status.value});
        }

        this.filtroChips = items;

        this.$emit('input', this.filtroChips);
      },

      removerFiltro(chip) {
        let isArray = Array.isArray(this.filtro[chip.chave]);

        if (isArray) {
          this.filtro[chip.chave] = [];
        } else {
          this.filtro[chip.chave] = '';
        }

        let index = this.filtroChips.findIndex(chip_ => chip_.chave == chip.chave);
        this.filtroChips.splice(index, 1);

        this.$emit('input', this.filtroChips);
      },

    },

  }
</script>

<style scoped>

</style>